module.exports = __webpack_public_path__ + "img/logo.82fc949c.png";